import { render, staticRenderFns } from "./TravelAccount.vue?vue&type=template&id=8a08493a&scoped=true"
import script from "./TravelAccount.vue?vue&type=script&lang=js"
export * from "./TravelAccount.vue?vue&type=script&lang=js"
import style0 from "./TravelAccount.vue?vue&type=style&index=0&id=8a08493a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a08493a",
  null
  
)

export default component.exports